export const BREAKPOINTS = {
  xxsmall: '412px',
  xsmall: '562px',
  small: '768px',
  medium: '1024px',
  large: '1340px',
  xlarge: '1750px',
} as const;

export type BreakpointSize = keyof typeof BREAKPOINTS;

export const BREAKPOINT_SIZES: BreakpointSize[] = [
  'xxsmall',
  'xsmall',
  'small',
  'medium',
  'large',
  'xlarge',
];
